/**
 * 全站权限配置
 *
 */
import { setCookie } from './utils/cookie';

import router from '@/router';
import store from '@/store';

/**
 * 导航守卫，相关内容可以参考:
 * https://router.vuejs.org/zh/guide/advanced/navigation-gqueryParamsuards.html
 */

router.beforeEach((to, from, next) => {

    const accessToken = typeof to.query.access_token === 'string' ? to.query.access_token.trim() : '';
    const loginToken = typeof to.query.login_token === 'string' ? to.query.login_token.trim() : '';

    if (accessToken && loginToken) {
        const cleanQuery = { ...to.query };

        delete cleanQuery.access_token;
        delete cleanQuery.login_token;

        // Token 属于一次性跳转凭证，先从浏览器地址栏移除，避免被历史记录或复制链接带走。
        // router.resolve 会保留正常 query 和 hash；守卫结束后仍通过 next 让 Vue Router 的当前路由同步为清理后的地址。
        const cleanUrl = router.resolve({
            path: to.path,
            query: cleanQuery,
            hash: to.hash,
        }).href;
        window.history.replaceState(window.history.state, document.title, cleanUrl);

        // 元空站只会同时下发两个 Token；缺少任一字段时不接管，保持原有渠道参数逻辑。
        // 业务意图：路由守卫只接收 Token，身份选择组件确认身份后才可请求 getUserInfo，避免未选择身份时提前进入工作台流程。
        store.commit('setUserIdentity', '');
        store.commit('setloginToken', loginToken);
        store.commit('setToken', accessToken);

        // replace 会重新进入守卫，但新路由已没有两个 Token，因此不会递归处理。
        next({
            path: to.path,
            query: cleanQuery,
            hash: to.hash,
            replace: true,
        });
        return;
    }

    const hasValidParams = Object.keys(to.query).some(key => {
        const value = to.query[key];
        return value !== undefined && value !== ''; // 排除 undefined 和 空字符串
    });
    if (hasValidParams) {
        if (to.query.partner_uuid) {
            sessionStorage.setItem('queryParams', JSON.stringify(to.query))
            if (to.query.access_token && to.query.login_token) {
                setCookie('queryParams', JSON.stringify(to.query))
                setCookie("login_token", to.query.login_token);
                setCookie("access_token", to.query.access_token);
                store.commit('setloginToken', to.query.login_token);
                store.commit('setToken', to.query.access_token);
            }

        }
        // console.log('to.query 包含有效参数:', to.query);
    } else {
        // console.log('to.query 没有有效参数');
    }

    let html = document.getElementsByTagName('html')[0]
    html.scrollTop = 0
    next()
});

router.afterEach(() => {});
